import ArticlesCarousel from 'components/ArticlesCarousel';
import { NextCustomImage as NextImage } from 'components/Image';
import cx from 'classnames';
import type { TopicPackageNativo } from 'interfaces/Home';
import SectionTitle from 'components/Globals/SectionTitle';
import Link from 'components/Globals/Base/Link';
import { ARTICLE_CARD_TEST_IDS } from 'constants/testsIds/articleComponents';
import * as S from './TopicPackageStyles';
import getCommonTestId from 'constants/testsIds/common';

export interface TopicPackageProps {
  packageItem: TopicPackageNativo;
  className?: string;
}

const TopicPackageItem: React.FC<TopicPackageProps> = ({ packageItem, className }: TopicPackageProps) => {
  const trackingdata = {
    contentPlacementCD: 'homepage sections',
    eventAction: 'feature article click',
    eventCategory: 'navigation',
    eventLabel: packageItem.name,
  };
  const isFullWidth = !packageItem.isMagazine || !packageItem.image.mediaItemUrl;

  return (
    <div>
      <S.PackageWrapper className={className}>
        {packageItem.customUrl ? (
          <Link
            href={packageItem.customUrl}
            type='primary'
            target='_blank'
            rel='noopener noreferrer'
          >
            <SectionTitle
              tag='h2'
              text={`${packageItem.name}`}
              className='title'
              variant='border'
              titleDataCy={getCommonTestId('TOPIC_PAGE_PACKAGE_TITLE')}
            />
          </Link>
        ) : (
          <SectionTitle
            titleDataCy={getCommonTestId('TOPIC_PAGE_PACKAGE_TITLE')}
            tag='h2'
            text={`${packageItem.name}`}
            className='title'
            variant='border'
          />
        )}
        {packageItem.description && (
          <S.Description
            data-cy={getCommonTestId('TOPIC_PAGE_PACKAGE_DESC')}
            className='description'
            dangerouslySetInnerHTML={{
              __html: packageItem.description,
            }}
          />
        )}
      </S.PackageWrapper>
      <S.PackageContent data-cy={getCommonTestId('TOPIC_PAGE_PACKAGE_CAROUSEL')}>
        {packageItem.isMagazine && packageItem.image && (
          <S.PackageImage>
            <Link
              href={packageItem.link}
              type='image'
              trackingData={
                trackingdata && {
                  ...trackingdata,
                  eventLabel: `image click : ${trackingdata.eventLabel || packageItem.link}`,
                }
              }
            >
              <NextImage
                width={200}
                height={400}
                src={packageItem.image.mediaItemUrl}
                alt={packageItem.image.altText || ''}
                title={packageItem.image.caption || ''}
                className='image-link'
                data-cy={ARTICLE_CARD_TEST_IDS.IMAGE}
              />
            </Link>
          </S.PackageImage>
        )}
        <ArticlesCarousel
          articles={packageItem.articles}
          className={cx('articles-carousel', { 'full-width': isFullWidth })}
          isFullWidth={isFullWidth}
        />
      </S.PackageContent>
    </div>
  );
};

export default TopicPackageItem;
